import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list Product-------
const getAllCategory = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.category.list + `${filter ? '?' + filter : ''}`);

    return data;
};
const GetAllCategoryQuery = (filter) => {
    return useQuery(['Category',filter], () => getAllCategory(filter));

};
// ------------------ Add Product-------
const addCategory = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.category.add, payload);
};
const AddCategoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addCategory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Category');
            toastMessage('success', 'Category Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Delete Category-------
const deleteCategory = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.category.delete + id);
};
const DeleteCategoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteCategory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Category');
            toastMessage('success', 'Cateogry Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Update Category-------
const updateCategory = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.category.update + id, payload);
};
const UpdateCategoryMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateCategory, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Category');
            toastMessage('success', 'Category Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllCategoryQuery, AddCategoryMutation, DeleteCategoryMutation, UpdateCategoryMutation };
